import styled, { injectGlobal, keyframes } from 'styled-components';

injectGlobal`
  html {
    width: 100%;
    height: 100%;
    height: 100vh;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  body {
    background: transparent;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -ms-word-break: break-all;
    word-break: break-all;
    /* Non standard for webkit */
    word-break: break-word;


    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    height: 100%;
    height: 100vh;
    min-height: 200px;
  }
  a {
    cursor: pointer;
    text-decoration: none !important;
  }

  h2 {
    -webkit-margin-before: 0;
    -webkit-margin-after: 0;
    -webkit-margin-start: 0;
    -webkit-margin-end: 0;
  }
  .alignment-right [dir=rtl],  .alignment-right [dir=ltr]{
      text-align: right !important;
       direction:rtl !important;
  }

  span[style="font-style:italic;"] *,
  span[style="font-style:italic;"] a {
    font-style: italic !important;
  }

  span[style="font-weight:bold;"] *,
  span[style="font-weight:bold;"] a {
    font-weight: bold !important;
  }

  span[style="text-decoration:underline;"] *,
  span[style="text-decoration:underline;"] {
    text-decoration: underline !important;
  }

  span[style="color: rgb(49, 55, 62);"]  {
   color: unset !important;
  }

  .rcvForAnswer{
    width: 100%;
  }
`;

export const FlexboxContainer = styled.div`
  padding: 30px 20px 20px;
  width: 100%;
  height: 100%;
  height: 100vh;
  min-height: 100%;
  min-height: 100vh;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox; /* IE 10 */
  display: -webkit-flex; /* Safari */
  display: flex; /* Modern browsers */
  -webkit-box-pack: start;
  -moz-box-pack: start;
  -ms-flex-pack: start;
  -ms-flex-direction: column;
  -webkit-justify-content: flex-start; /* Safari */
  -webkit-flex-direction: column; /* Safari */
  -webkit-align-items: stretch; /* Safari */
  -webkit-align-content: stretch; /* Safari */
  flex-flow: column;
  flex-direction: column;
  justify-content: flex-start; /* align items in Main Axis */
  align-items: stretch; /* align items in Cross Axis */
  align-content: stretch; /* Extra space in Cross Axis */

  box-sizing: border-box;
  @media screen and (min-width: 320px) {
    padding: 30px 40px;
  }
  &.mobile-mode {
    padding-left: 5px !important;
    padding-right: 5px !important;
    top: 0;
    bottom: 0;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: normal;
    -webkit-hyphens: none !important;
    -moz-hyphens: none !important;
    -ms-hyphens: none !important;
    hyphens: none !important;
  }
`;

export const Content = styled.div`
  box-sizing: border-box;
  .faq-header {
    position: relative;
    .faq-title {
      width: 62%;
    }
    .search-label,
    .search-no-results {
      margin-top: 25px;
    }
  }

  .categories {
    .category {
      display: inline-block;
      cursor: pointer;
      padding-right: 40px;

      &.category-selected {
        font-weight: bold !important;
        text-shadow: 0 0 !important;
        cursor: default;
      }
    }
  }
`;

export const ClickableArea = styled.span`
  display: none;
  width: 100%;
  height: 100%;
  background-color: transparent;
  cursor: pointer;
  @media (max-width: 455px) {
    display: inline-block;
  }
`;

export const flexboxItem = styled.div`
  padding-bottom: 0;
  :last-child {
    padding-bottom: 0;
  }
  &.footer {
    height: 10px;
  }
`;
export const FlexboxItemGrow = styled.div`
  flex: 1; /* same as flex: 1 1 auto; */
  flex-grow: 1;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1; /* Safari */
  flex-shrink: 1;
  flex-basis: auto;
`;
